import $ from 'jquery'

const previousPageUrl = document.referrer;
let search = '/?s=';
if (previousPageUrl.indexOf(search) > -1) {
  $('#home-link').attr('href', previousPageUrl).text('Back to Results');
}